/** 秒数を `分:秒` のタイムコードへ変換する。 */
export function formatTimecode(seconds: number, decimals: number): string {
	const factor = 10 ** decimals;
	// 分・秒への分離より前に丸めることで、秒側の丸め結果が60に達しても分へ繰り上がるようにする。
	const totalUnits = Math.max(0, Math.round(seconds * factor));
	const minutes = Math.floor(totalUnits / factor / 60);
	const secondsUnits = totalUnits - minutes * 60 * factor;
	const formattedSeconds =
		decimals === 0
			? String(secondsUnits).padStart(2, "0")
			: (secondsUnits / factor).toFixed(decimals).padStart(decimals + 3, "0");
	return `${minutes}:${formattedSeconds}`;
}
